import { useSelector } from "react-redux";
import {
  useGetPendingTableDataQuery,
  useUpdatePendingTableHeadDataMutation,
} from "../../../../store/queries/Recheck";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../../store/slices/Global";
import { toast } from "react-toastify";
import { assignRecheckAll, assignWork } from "../api";
import {
  getCardAssignedList,
  getCardPendingList,
  updateConfig,
} from "../../../../store/slices/Staff/recheckStaffSlice";
import { Button } from "@wac-ui-dashboard/wac_component_library";

const usePendingTable = () => {
  let paginationOptions = [
    { label: "20 Per page", value: 20 },
    { label: "40 Per page", value: 40 },
    { label: "60 Per page", value: 60 },
  ];
  const dispatch = useDispatch();
  const staffState = useSelector((state) => state.recheckStaff);
  const { tableFields, showEditModal, globalRemarkModal } = useSelector(
    (state) => state.global
  );

  const slug = sessionStorage?.getItem("slug");
  const {
    data: pendingTableData = {},
    isFetching,
    isLoading,
    refetch,
  } = useGetPendingTableDataQuery({
    receipt_id: staffState.gliData?.id,
    search: staffState.pendingSearch,
    page_size: staffState.currentPageSize,
    page: staffState.currentPageTab,
    process_slug: slug,
  });

  const [updatePendingFields] = useUpdatePendingTableHeadDataMutation();

  useEffect(() => {
    dispatch(
      globalUpdateConfig((state) => {
        state.tableFields = pendingTableData?.data?.fields;
      })
    );
    // eslint-disable-next-line
  }, [pendingTableData]);

  const handleRemarksClick = (data) => {
    dispatch(
      globalUpdateConfig((state) => {
        state.globalRemarkId = data?.id;
        state.globalRemarkModal = true;
      })
    );
  };

  const handleModalClose = () => {
    dispatch(globalUpdateConfig((state) => (state.globalRemarkModal = false)));
  };

  const getRow = (feild, data) => {
    const rows = {
      common: (feild, data) => <p className="pro-mb-0">{data[feild]}</p>,
      status: (_, data) =>
        data?.status === "Rejected" ? (
          <span className={"pro-badge badge-danger-outline pro-d-inline-block"}>
            {"Rejected"}
          </span>
        ) : data?.status === "Marked" ? (
          <span className={"outline-primary pro-badge pro-d-inline-block"}>
            {"Marked"}
          </span>
        ) : data?.status === "Completed" ? (
          <span className={"outline-success pro-badge pro-d-inline-block"}>
            {"Completed"}
          </span>
        ) : data?.status === "Pending" ? (
          <span className={"outline-warning pro-badge pro-d-inline-block"}>
            {"Pending"}
          </span>
        ) : (
          <span className={"outline pro-badge pro-d-inline-block"}>
            {data?.status}
          </span>
        ),
      action: (_, data) => (
        <p className="pro-mb-0">
          {
            <Button
              className={"pro-btn-primary"}
              onClick={() => handleRemarksClick(data)}
            >
              Remarks
            </Button>
          }
        </p>
      ),
    };
    return rows?.[feild]?.(feild, data) ?? rows["common"](feild, data);
  };

  const handleAssignClick = (ids) => {
    let data = {
      item_details_id: ids,
      process_slug: slug,
    };
    assignWork(data).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          getCardPendingList({
            page: 1,
            per_page: 10,
            search: "",
            date: [],
            item_type: [],
            shop: [],
            status: [],
            process_slug: slug,
          })
        );
        dispatch(
          getCardAssignedList({
            page: 1,
            per_page: 10,
            search: "",
            date: [],
            item_type: [],
            shop: [],
            status: [],
            process_slug: slug,
          })
        );
        refetch();
        if (pendingTableData?.data?.data.length <= 0) {
          dispatch(
            updateConfig((state) => {
              state.showTable = false;
              state.showAssignedTable = false;
            })
          );
        }
        toast.success("Assign success");
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  // const handleAssignAll = () => {
  //   let ids = [];
  //   pendingTableData?.data?.data?.map((item) => {
  //     return ids?.push(item?.id);
  //   });
  //   let data = {
  //     item_details_id: ids,
  //   };
  //   assignWork(data).then((response) => {
  //     if (response?.data?.status_code === 200) {
  //       dispatch(
  //         getCardPendingList({
  //           page: 1,
  //           per_page: 10,
  //           search: "",
  //           date: [],
  //           item_type: [],
  //           shop: [],
  //           status: [],
  //         })
  //       );
  //       dispatch(
  //         getCardAssignedList({
  //           page: 1,
  //           per_page: 10,
  //           search: "",
  //           date: [],
  //           item_type: [],
  //           shop: [],
  //           status: [],
  //         })
  //       );
  //       dispatch(
  //         updateConfig((state) => {
  //           state.showTable = false;
  //           state.showAssignedTable = false;
  //         })
  //       );
  //       toast.success("Assign success");
  //     } else {
  //       toast.error("Something went wrong");
  //     }
  //   });
  // };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPageTab = 1;
      })
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageTab = page;
      })
    );
  };

  const handleSearch = (e) => {
    dispatch(updateConfig((state) => (state.pendingSearch = e?.target?.value)));
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };
  const handleBulkAssignRecheckAll = () => {
    let data = {
      receipt_id: staffState?.gliData?.id,
      process_slug: slug,
    };
    assignRecheckAll(data).then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success(response?.data?.message);
        refetch();
        dispatch(
          updateConfig((state) => {
            state.cardData.Pending = [];
            state.cardData.Assigned = [];
          })
        );
        dispatch(
          getCardPendingList({
            search: "",
            page: 1,
            process_slug: slug,
          })
        );
        dispatch(
          getCardAssignedList({
            search: "",
            page: 1,
            process_slug: slug,
          })
        );
        dispatch(updateConfig((state) => (state.clear = true)));
        const timeOut = setTimeout(() => {
          dispatch(updateConfig((state) => (state.clear = false)));
          clearTimeout(timeOut);
        }, 1000);
      } else if (response?.status_code === 403) {
        toast.error(response?.message ?? "Error ");
      } else {
        toast.error(response?.data?.message);
      }
    });
  };

  return {
    isLoading,
    staffState,
    isFetching,
    tableFields,
    showEditModal,
    pendingTableData,
    globalRemarkModal,
    paginationOptions,
    getRow,
    refetch,
    handleSearch,
    handlePageSize,
    handlePagination,
    handleModalClose,
    handleAssignClick,
    updatePendingFields,
    handleEditColumnsClick,
    handleBulkAssignRecheckAll,
  };
};

export default usePendingTable;
